<ion-header>
  <ion-row class="ion-align-items-center">
    <div class="column">
      <div class="back" (click)="back()">
        <img src="assets/icon/back.svg" alt="" />
      </div>
      <div class="logo">{{ 'systemModal.title' | translate }}</div>
    </div>
  </ion-row>
</ion-header>
<ion-content [forceOverscroll]="false">
  <div class="wrapper">
    <div class="state-machine">
      <div class="state-machine__icon">
        <img src="assets/icon/state-machine.svg" alt="" />
      </div>
      <div class="state-machine__status">
        <div class="state-machine__status--heading">{{ 'systemModal.state' | translate }}</div>
        @if (fridgeService?.activeFridge?.connected && stateMachinePreviousState) {
          <div>
            {{ 'systemModal.before' | translate }}
            {{ stateMachinePreviousState }}
          </div>
        }
      </div>
      @if (fridgeService?.activeFridge?.connected) {
        <div
          class="state-machine__current"
          [class.error]="stateMachineState === 'Error' || stateMachineState === 'Burgling'"
          >
          {{ stateMachineState }}
        </div>
      }
    </div>
    @if (fridgeService.activeFridge?.connected && stateMachineState === 'Error') {
      <div class="error-reason">
        {{ stateMachineReason || '-' }}
      </div>
    }
    <div class="subsystem-wrapper">
      @for (subsystem of objectKeys(subsystemsState); track subsystem) {
        <div class="subsystem">
          <div class="subsystem__name">{{ getFormattedName(subsystem) }}</div>
          <div [class]="['subsystem__status', subsystemsState[subsystem]]">
            {{ subsystemsState[subsystem] }}
          </div>
        </div>
      }
    </div>

    <div class="state-machine">
      <div class="state-machine__icon">
        <img src="assets/icon/server-settings.svg" alt="" />
      </div>
      <div class="state-machine__status">
        <div class="state-machine__status--heading">{{ 'systemModal.payment_t' | translate }}</div>
        <div>{{ 'systemModal.payment_s' | translate }}</div>
      </div>
    </div>
    @if (fridgeService.activeFridge.payment) {
      <div class="subsystem-wrapper server">
        @if (fridgeService.activeFridge.payment.paymentDevice !== paymentDevice.USB_MIFARE) {
          <div
            class="subsystem"
            >
            <div class="subsystem__name">
              {{ 'systemModal.reservation' | translate }}
              <div class="amount">
                @if (isReservationAmountPerDoor) {
                  @for (door of reservationAmountPerDoor; track door) {
                    <span>
                      {{ fridgeService.getActiveFridgeCurrency() }}{{ door.reservationAmount }}
                    </span>
                  }
                }
                @if (!isReservationAmountPerDoor) {
                  {{ fridgeService.getActiveFridgeCurrency() }}{{ getReservationAmount() }}
                }
              </div>
            </div>
            <div
              id="open-modal"
              class="subsystem__command restart"
              (click)="setModalInfo(fridgeService.activeFridge.payment?.reservationAmount)"
              >
              {{ 'systemModal.change' | translate }}
            </div>
            <ion-modal [isOpen]="amountModalStatus" [backdropDismiss]="false" class="input-modal">
              <ng-template>
                <ion-content>
                  @if (doorsCount > 1) {
                    <ion-item>
                      <ion-checkbox [(ngModel)]="isReservationAmountPerDoor">{{
                        'systemModal.door_based_reservation_amount' | translate
                      }}</ion-checkbox>
                    </ion-item>
                  }
                  @if (!isReservationAmountPerDoor) {
                    <ion-item>
                      <ion-label position="stacked"
                        >{{ 'systemModal.enter_reservation_amount' | translate }}
                      </ion-label>
                      <ion-input
                        type="text"
                        [(ngModel)]="reservationAmount"
                        placeholder="Reservation amount"
                        (keypress)="decimalOnlyValidation($event)"
                      ></ion-input>
                    </ion-item>
                  }
                  @if (isReservationAmountPerDoor) {
                    @for (door of reservationAmountPerDoor; track door) {
                      <ion-item>
                        <ion-label position="stacked"
                          >{{ 'systemModal.reservation_amount_door' | translate }} #{{
                          door.rackNumber
                          }}</ion-label
                          >
                          <ion-input
                            type="text"
                            [(ngModel)]="door.reservationAmount"
                            placeholder="Reservation amount"
                            (keypress)="decimalOnlyValidation($event)"
                          ></ion-input>
                        </ion-item>
                      }
                    }
                    <div class="modal-actions">
                      <div class="save" (click)="saveReservationAmount()">
                        {{ 'systemModal.save' | translate }}
                      </div>
                      <div
                        class="save cancel"
                        (click)="amountModalStatus = false; initReservationAmount()"
                        >
                        {{ 'systemModal.cancel' | translate }}
                      </div>
                    </div>
                  </ion-content>
                </ng-template>
              </ion-modal>
            </div>
          }
          <div class="subsystem">
            <div class="subsystem__name ip">
              <div>{{ 'systemModal.startDemo' | translate }}</div>
            </div>
            @if (
              fridgeService.activeFridge?.stateMachine?.state === 'WaitForCard' &&
              fridgeService.activeFridge?.connected &&
              fridgeService.activeFridge?.demoPaymentConfig?.enabled) {
              <div
                class="subsystem__command start"
                (click)="executeFridgeCommand('startDemoPurchase')"
                >
                {{ 'systemModal.start' | translate }}
              </div>
            } @else {
              <div class="subsystem__command unavailable">{{ 'systemModal.disabled' | translate }}</div>
            }
          </div>
        </div>
      }

      <div class="state-machine">
        <div class="state-machine__icon">
          <img src="assets/icon/server-settings.svg" alt="" />
        </div>
        <div class="state-machine__status">
          <div class="state-machine__status--heading">
            {{ 'systemModal.employee_cards' | translate }}
          </div>
          <div>
            {{ 'systemModal.a_employee' | translate }}:
            {{ fridgeService.activeFridge?.employeeAccessList?.length || 0 }}
          </div>
        </div>
      </div>
      @if (fridgeService.activeFridge?.connected) {
        <div class="subsystem-wrapper server">
          @if (['IP_ZVT', 'USB_MIFARE'].includes(fridgeService.activeFridge?.payment.paymentDevice)) {
            <div
              class="subsystem"
              >
              <div class="subsystem__name">{{ 'systemModal.add_employee' | translate }}</div>
              @if (
                fridgeService.activeFridge?.stateMachine?.state === 'WaitForCard' && !loadingEmployee) {
                <div
                  class="subsystem__command restart"
                  (click)="executeFridgeCommand('addEmployeeCard')"
                  >
                  {{ 'systemModal.add' | translate }}
                </div>
              } @else {
                @if (!loadingEmployee) {
                  <div class="subsystem__command unavailable">
                    {{ 'systemModal.disabled' | translate }}
                  </div>
                }
              }
              @if (loadingEmployee) {
                <ion-spinner name="crescent"></ion-spinner>
              }
            </div>
          }
          @if (['IP_ZVT', 'USB_MIFARE'].includes(fridgeService.activeFridge?.payment.paymentDevice)) {
            <div
              class="subsystem"
              >
              <div class="subsystem__name">{{ 'systemModal.delete_employee' | translate }}</div>
              @if (
                fridgeService.activeFridge?.stateMachine?.state === 'WaitForCard' && !loadingEmployee) {
                <div
                  class="subsystem__command restart"
                  (click)="executeFridgeCommand('removeEmployeeCard')"
                  >
                  {{ 'systemModal.remove' | translate }}
                </div>
              } @else {
                @if (!loadingEmployee) {
                  <div class="subsystem__command unavailable">
                    {{ 'systemModal.disabled' | translate }}
                  </div>
                }
              }
              @if (loadingEmployee) {
                <ion-spinner name="crescent"></ion-spinner>
              }
            </div>
          }
        </div>
      }

      @if (fridgeService.activeFridge?.connected) {
        <div class="state-machine">
          <div class="state-machine__icon">
            <img src="assets/icon/ai-settings.svg" alt="" />
          </div>
          <div class="state-machine__status">
            <div class="state-machine__status--heading">{{ 'systemModal.ai_t' | translate }}</div>
            <div>{{ 'systemModal.ai_s' | translate }}</div>
          </div>
        </div>
      }
      @if (fridgeService.activeFridge?.connected) {
        <div class="subsystem-wrapper server">
          <div class="subsystem">
            <div class="subsystem__name">{{ 'systemModal.start' | translate }} AI</div>
            <div class="subsystem__command start" (click)="executeAiCommand('start')">
              {{ 'systemModal.start' | translate }}
            </div>
          </div>
          <div class="subsystem">
            <div class="subsystem__name">{{ 'systemModal.stop' | translate }} AI</div>
            <div class="subsystem__command stop" (click)="executeAiCommand('stop')">
              {{ 'systemModal.stop' | translate }}
            </div>
          </div>
          <div class="subsystem">
            <div class="subsystem__name">{{ 'systemModal.restart' | translate }} AI</div>
            <div class="subsystem__command restart" (click)="executeAiCommand('restart')">
              {{ 'systemModal.restart' | translate }}
            </div>
          </div>
        </div>
      }

      @if (fridgeService.activeFridge?.connected) {
        <div class="state-machine">
          <div class="state-machine__icon">
            <img src="assets/icon/server-settings.svg" alt="" />
          </div>
          <div class="state-machine__status">
            <div class="state-machine__status--heading">{{ 'systemModal.server_t' | translate }}</div>
            <div>{{ 'systemModal.server_s' | translate }}</div>
          </div>
        </div>
      }
      @if (fridgeService.activeFridge?.connected) {
        <div class="subsystem-wrapper server">
          <div class="subsystem">
            <div class="subsystem__name">{{ 'systemModal.re_calc' | translate }}</div>
            <div class="subsystem__command restart" (click)="executeFridgeCommand('resetInventory')">
              {{ 'systemModal.reset' | translate }}
            </div>
          </div>
          <div class="subsystem">
            <div class="subsystem__name">{{ 'systemModal.set_zero' | translate }}</div>
            <div class="subsystem__command restart" (click)="executeFridgeCommand('setZero')">
              {{ 'systemModal.set' | translate }}
            </div>
          </div>
          <div class="subsystem">
            <div class="subsystem__name">{{ 'systemModal.restart_s' | translate }}</div>
            <div class="subsystem__command restart" (click)="executeFridgeCommand('restartService')">
              {{ 'systemModal.restart_b' | translate }}
            </div>
          </div>
          <div class="subsystem">
            <div class="subsystem__name">{{ 'systemModal.shut_down' | translate }}</div>
            <div class="subsystem__command stop" (click)="executeFridgeCommand('shutdown')">
              {{ 'systemModal.shut_down_b' | translate }}
            </div>
          </div>
          <div class="subsystem">
            <div class="subsystem__name">{{ 'systemModal.reboot_s' | translate }}</div>
            <div class="subsystem__command restart" (click)="executeFridgeCommand('reboot')">
              {{ 'systemModal.reboot' | translate }}
            </div>
          </div>
        </div>
      }

      <div class="state-machine">
        <div class="state-machine__icon">
          <img src="assets/icon/server-settings.svg" alt="" />
        </div>
        <div class="state-machine__status">
          <div class="state-machine__status--heading">
            {{ 'systemModal.service_title' | translate }}
          </div>
          <div>{{ 'systemModal.service_sub' | translate }}</div>
        </div>
      </div>
      <div class="subsystem-wrapper server">
        <div class="subsystem">
          <div class="subsystem__name">
            {{ 'systemModal.service_code' | translate }}
            {{ fridgeService.activeFridge.serviceCode?.enabled ? '******' : '' }}
          </div>
          <div
            id="open-modal-service-code"
            class="subsystem__command restart"
            (click)="setAccessModalInfo(fridgeService.activeFridge.serviceCode)"
            >
            {{
            fridgeService.activeFridge.serviceCode?.enabled
            ? i18n.instant('systemModal.change')
            : i18n.instant('systemModal.enable')
            }}
          </div>
          <ion-modal [isOpen]="accessModalStatus" [backdropDismiss]="false" class="input-modal">
            <ng-template>
              <ion-content class="ion-padding">
                <ion-item>
                  <ion-label position="stacked" text-no-wrap>
                    {{ 'systemModal.service_modal' | translate }}</ion-label
                    >
                    <ion-input
                      type="text"
                      [(ngModel)]="serviceCode"
                      placeholder="Service Code"
                      (keypress)="numberOnlyValidation($event)"
                      maxlength="6"
                    ></ion-input>
                  </ion-item>
                  <div class="modal-actions">
                    <div class="save" (click)="enableServiceCode(true)">
                      {{ 'systemModal.set' | translate }}
                    </div>
                    <div class="save cancel" (click)="enableServiceCode(false)">
                      {{ 'systemModal.disable' | translate }}
                    </div>
                  </div>
                </ion-content>
              </ng-template>
            </ion-modal>
          </div>
        </div>

        <div class="state-machine">
          <div class="state-machine__icon">
            <img src="assets/icon/server-settings.svg" alt="" />
          </div>
          <div class="state-machine__status">
            <div class="state-machine__status--heading">{{ 'systemModal.a_t' | translate }}</div>
            <div>{{ 'systemModal.a_s' | translate }}</div>
          </div>
        </div>
        <div class="subsystem-wrapper server">
          <div class="subsystem">
            <div class="subsystem__name">{{ 'systemModal.voice' | translate }}</div>
            <div
              class="subsystem__command"
              (click)="setTabletSettingSound(!fridgeService.activeFridge.tabletSetting?.soundEnabled)"
              [ngClass]="fridgeService.activeFridge.tabletSetting?.soundEnabled ? 'stop' : 'start'"
              >
              {{
              fridgeService.activeFridge.tabletSetting?.soundEnabled
              ? i18n.instant('systemModal.disable')
              : i18n.instant('systemModal.enable')
              }}
            </div>
          </div>
          @if (fridgeService.activeFridge.tabletSetting?.soundEnabled) {
            <div class="subsystem">
              <div class="subsystem__name">
                {{ 'systemModal.volume' | translate }}
                <span class="amount">{{ soundVolume | number : '1.0-0' }}%</span>
              </div>
              <div class="subsystem__command restart" (click)="openVolumeModal()">
                {{ 'systemModal.change' | translate }}
              </div>
            </div>
          }

          <ion-modal
            [isOpen]="volumeModalStatus"
            [backdropDismiss]="false"
            class="input-modal"
            style="--height: 200px"
            >
            <ng-template>
              <ion-content class="ion-padding volume-modal">
                <div class="volume-block modal">
                  <div class="volume-row">
                    <label>{{ 'systemModal.volume' | translate }}</label>
                    <input
                      style="margin: 0 20px"
                      type="range"
                      min="0"
                      max="100"
                      step="1"
                      [(ngModel)]="tempSoundVolume"
                      />
                      <span class="volume-value" style="width: 60px; display: block"
                        >{{ tempSoundVolume | number : '1.0-0' }}%</span
                        >
                      </div>
                      <div class="volume-actions">
                        <div
                          class="subsystem__command start"
                          [class.disabled]="savingVolume"
                          (click)="saveVolumeFromModal()"
                          >
                          {{ 'systemModal.save' | translate }}
                        </div>
                        <div class="subsystem__command cancel" (click)="closeVolumeModal()">
                          {{ 'systemModal.cancel' | translate }}
                        </div>
                      </div>
                    </div>
                  </ion-content>
                </ng-template>
              </ion-modal>
            </div>

            <div class="state-machine">
              <div class="state-machine__icon">
                <img src="assets/icon/server-settings.svg" alt="" />
              </div>
              <div class="state-machine__status">
                <div class="state-machine__status--heading">{{ 'systemModal.h_t' | translate }}</div>
                <div>{{ 'systemModal.h_s' | translate }}</div>
              </div>
            </div>
            @if (fridgeService.activeFridge?.hardwareInfo) {
              <div class="subsystem-wrapper server">
                <div class="subsystem">
                  <div class="subsystem__name">
                    {{ 'systemModal.s_ip' | translate }}
                    <span class="amount">{{ fridgeService.activeFridge.hardwareInfo.fridgeDeviceIp }}</span>
                  </div>
                </div>
                @if (
                  fridgeService.activeFridge &&
                  ['IP_ZVT', 'IP_TIM', 'ADYEN'].includes(fridgeService.activeFridge.payment?.paymentDevice)
                  ) {
                  <div
                    class="subsystem"
                    >
                    <div class="subsystem__name ip">
                      <div>{{ 'systemModal.p_ip' | translate }}</div>
                      <div class="amount">{{ fridgeService.activeFridge?.hardwareInfo?.posIp || '' }}</div>
                    </div>
                    @if (loadingPos) {
                      <div class="subsystem__command search-pos searching">
                        <ion-spinner name="crescent"></ion-spinner>
                        {{ 'systemModal.searching' | translate }}
                      </div>
                    } @else if (fridgeService.activeFridge?.connected) {
                      <div
                        class="subsystem__command search-pos"
                        (click)="executeFridgeCommand('searchPOS')"
                        >
                        {{ 'systemModal.search' | translate }}
                      </div>
                    }
                  </div>
                }
                @if (posTerminals && posTerminals.length > 0 && !loadingPos) {
                  <div class="subsystem pos">
                    <div class="subsystem__name">{{ 'systemModal.f_pos' | translate }}</div>
                    @for (pos of posTerminals; track pos.ip) {
                      <div class="pos-list">
                        <div class="amount">
                          {{ pos.ip }}
                          @if (pos.terminalId) {
                            <span class="terminal-id">TID: {{ pos.terminalId }}</span>
                          }
                        </div>
                        @if (pos.ip !== fridgeService.activeFridge?.hardwareInfo?.posIp) {
                          <div
                            class="subsystem__command search-pos"
                            (click)="setPosIp(pos.ip)"
                            >
                            {{ 'systemModal.set' | translate }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }

            @if (isEndOfDayRelevant) {
              <div class="subsystem-wrapper server">
                <div class="subsystem">
                  <div class="subsystem__name ip">
                    <div>{{ 'systemModal.eod_last' | translate }}</div>
                    <div class="amount" [class.eod-error]="isEndOfDayNeeded">
                      @if (fridgeService.activeFridge?.lastEndOfDayAt) {
                        {{ fridgeService.activeFridge.lastEndOfDayAt | date: 'dd.MM.y HH:mm' }}
                      } @else {
                        {{ 'systemModal.eod_never' | translate }}
                      }
                    </div>
                  </div>
                  @if (canRunEndOfDay) {
                    <div class="subsystem__command restart" (click)="runEndOfDay()">
                      {{ 'systemModal.eod_run' | translate }}
                    </div>
                  }
                  @if (loadingEndOfDay) {
                    <ion-spinner name="crescent"></ion-spinner>
                  } @else if (isEndOfDayInProgress) {
                    <div class="amount">{{ 'systemModal.eod_in_progress' | translate }}</div>
                  }
                </div>
                @if (fridgeService.activeFridge?.endOfDayStatus?.needEndOfDay) {
                  <div class="subsystem">
                    <div class="subsystem__name">
                      {{ 'systemModal.eod_failed' | translate }}
                      <span class="amount" [class.eod-error]="fridgeService.activeFridge.endOfDayStatus.autoAttemptsExhausted">
                        {{ fridgeService.activeFridge.endOfDayStatus.failedAttempts }}
                        @if (fridgeService.activeFridge.endOfDayStatus.autoAttemptsExhausted) {
                          · {{ 'systemModal.eod_auto_stopped' | translate }}
                        }
                      </span>
                    </div>
                  </div>
                  @if (fridgeService.activeFridge.endOfDayStatus.lastError) {
                    <div class="subsystem">
                      <div class="subsystem__name ip">
                        <div>{{ 'systemModal.eod_error' | translate }}</div>
                        <div class="amount eod-error">{{ fridgeService.activeFridge.endOfDayStatus.lastError }}</div>
                      </div>
                    </div>
                  }
                  @if (fridgeService.activeFridge.endOfDayStatus.blockedBy?.length) {
                    <div class="subsystem">
                      <div class="subsystem__name">
                        {{ 'systemModal.eod_blocked' | translate }}
                        <span class="amount eod-error">{{ fridgeService.activeFridge.endOfDayStatus.blockedBy.length }}</span>
                      </div>
                    </div>
                  }
                }
              </div>
            }

            <div class="state-machine">
              <div class="state-machine__icon">
                <img src="assets/icon/server-settings.svg" alt="" />
              </div>
              <div class="state-machine__status">
                <div class="state-machine__status--heading">
                  {{ 'systemModal.Maintenance' | translate }}
                </div>
                <div>{{ 'systemModal.Maintenance_s' | translate }}</div>
              </div>
            </div>
            <div class="subsystem-wrapper server">
              <div class="subsystem">
                <div class="subsystem__name">{{ 'systemModal.m_factory' | translate }}</div>
                <div
                  class="subsystem__command"
                  (click)="setMode({ factoryModeEnabled: !fridgeService.activeFridge.factoryMode?.active })"
                  [ngClass]="fridgeService.activeFridge.factoryMode?.active ? 'start' : 'stop'"
                  >
                  {{
                  fridgeService.activeFridge.factoryMode?.active
                  ? i18n.instant('systemModal.disable')
                  : i18n.instant('systemModal.enable')
                  }}
                </div>
              </div>
              <div class="subsystem">
                <div class="subsystem__name">{{ 'systemModal.m_stop_sale' | translate }}</div>
                <div
                  class="subsystem__command"
                  (click)="setMode({ stopSaleEnabled: !fridgeService.activeFridge.stopSale?.active })"
                  [ngClass]="fridgeService.activeFridge.stopSale?.active ? 'start' : 'stop'"
                  >
                  {{
                  fridgeService.activeFridge.stopSale?.active
                  ? i18n.instant('systemModal.disable')
                  : i18n.instant('systemModal.enable')
                  }}
                </div>
              </div>
            </div>

            @if (fridgeService.activeFridge?.connected) {
              <div class="state-machine">
                <div class="state-machine__icon">
                  <img src="assets/icon/server-settings.svg" alt="" />
                </div>
                <div class="state-machine__status">
                  <div class="state-machine__status--heading">{{ 'systemModal.d_t' | translate }}</div>
                  <div>{{ 'systemModal.d_s' | translate }}</div>
                </div>
              </div>
            }
            @if (fridgeService.activeFridge?.connected) {
              <div class="subsystem-wrapper server">
                <div class="subsystem">
                  <div class="subsystem__name">{{ 'systemModal.wight_s' | translate }}</div>
                  <div class="subsystem__command weight" (click)="toggleWeightSensors()">
                    {{
                    fridgeService.showWeightSensorsValues
                    ? i18n.instant('systemModal.hide')
                    : i18n.instant('systemModal.show')
                    }}
                  </div>
                </div>
                <div class="subsystem">
                  <div class="subsystem__name">{{ 'systemModal.camera' | translate }}</div>
                  @if (userService.isInternal) {
                    <div
                      class="subsystem__command weight"
                      (click)="toggleFrames()"
                      >
                      {{
                      fridgeService.streamer.showFrames
                      ? i18n.instant('systemModal.hide')
                      : i18n.instant('systemModal.show')
                      }}
                    </div>
                  }
                  <ion-modal
                    [isOpen]="fridgeService.streamer.showFrames"
                    [backdropDismiss]="false"
                    class="frames-modal"
                    >
                    <ng-template>
                      <ion-content>
                        @for (camera of this.fridgeService.streamer.frames; track camera; let i = $index) {
                          <ion-item
                            class="ion-no-padding"
                            >
                            <div class="camera">
                              <h5>Camera #{{ i }}</h5>
                              <img [src]="camera.src" />
                              <span class="timestamp">{{ camera.timestamp }}</span>
                            </div>
                          </ion-item>
                        }
                        <div class="modal-actions">
                          <div class="save cancel" (click)="toggleFrames()">
                            {{ 'systemModal.cancel' | translate }}
                          </div>
                        </div>
                      </ion-content>
                    </ng-template>
                  </ion-modal>
                </div>
                <div class="subsystem">
                  <div class="subsystem__name">{{ 'systemModal.network' | translate }}</div>
                  @if (!loadingTraffic) {
                    <div class="subsystem__command" (click)="requestNetworkTraffic()">
                      {{ 'systemModal.request' | translate }}
                    </div>
                  }
                  @if (loadingTraffic) {
                    <ion-spinner name="crescent"></ion-spinner>
                  }
                </div>
                @if (trafficItems && !loadingTraffic) {
                  <div class="subsystem pos">
                    @for (t of trafficItems; track t; let i = $index) {
                      <div class="traffic-list">
                        <div class="name">{{ t.title }}</div>
                        <div class="traffic">
                          <span class="traffic-item">{{ t.total }}</span>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }

          </div>
        </ion-content>
